import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { PermitProjectFacilityAopService } from './permit-project-facility-aop.service';

@Injectable({
  providedIn: 'root'
})
export class ProjectFacilitySponsorService {

  private aopSponsorSource = new BehaviorSubject<ProjectFacilitySponsorApi[]>([]);
  aopSponsors$ = this.aopSponsorSource.asObservable();

  constructor(
    @Inject('BASE_URL') private baseUrl: string,
    private http: HttpClient,
    private toastrService: ToastrService,
    private pfaopService: PermitProjectFacilityAopService
  ) { }

  getSponsors(permitId?: number) {
    this.http.get<ProjectFacilitySponsorApi[]>(`${this.baseUrl}api/projectfacilitysponsor/search?permitAnnualOperatingPlanId=${permitId}`)
      .subscribe(response => {
      if (!!response) {
        this.changeSponsor(response);
      } else {
        this.changeSponsor([]);
      }
    },
      error => console.error(error)
    );
  }

  //this can handle both creation and subsequent update of a list of 
  //ProjectFacilitySponsorApi that is associated with a permitAopId
  putSponsors(permitAopId: number, data: ProjectFacilitySponsorApi[]) {
    /*
      projectFacilitySponsorId: data.projectFacilitySponsorId,
      permitAnnualOperatingPlanId: data.permitAnnualOperatingPlanId,
      payingEntityName: data.payingEntityName,
      listPerAcreFootCostBasisForRechargeId: data.listPerAcreFootCostBasisForRechargeId,
      listPerAcreFootCostBasisForRechargeName: data.listPerAcreFootCostBasisForRechargeName,
      maxVolumePerYearAF: data.maxVolumePerYearAF,
      contractFileUploadListId: data.contractFileUploadListId,
      */
    var dataPut: any = {
      SponsorsApi: data,
    };
    this.http.put<any>(`${this.baseUrl}api/projectfacilitysponsor/${permitAopId}`, dataPut).subscribe(
      response => {
        if (response) {
          this.getSponsors(permitAopId);
          this.toastrService.success("Sponsor updated.");
        } else {
          
        }
      },
      error => {
        console.error(error);
        this.toastrService.success("Sponsor updated failed.");
      }
    );
  }

  // POST AOP NOW A PART OF APPLICATION PACKAGE SERVICE

  changeSponsor(sponsors: ProjectFacilitySponsorApi[]) {
    this.aopSponsorSource.next(sponsors);
  }

}

export interface ProjectFacilitySponsorApi {
  projectFacilitySponsorId: number,
  permitAnnualOperatingPlanId: number,
  payingEntityName?: string,
  listPerAcreFootCostBasisForRechargeId?: number,
  listPerAcreFootCostBasisForRechargeName?: string,
  maxVolumePerYearAF?: number,
  contractFileUploadListId?: number,
}